import * as MaterialUiIcons from "@mui/icons-material";
import * as React from "react";
import { FunctionComponent } from "react";

const CloseIcon: FunctionComponent = () => <MaterialUiIcons.Close />;

export default CloseIcon;
